"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var DoneOutlineRounded_1 = __importDefault(require("@material-ui/icons/DoneOutlineRounded"));
var TextField_1 = __importDefault(require("../../../TextField"));
var IconButton_1 = __importDefault(require("../../../IconButton"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            borderBottom: "1px solid " + theme.palette.grey[200],
            paddingTop: 0,
            paddingBottom: 0,
        },
        textField: {
            lineHeight: 1.5,
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            paddingLeft: 0,
            paddingRight: 0,
            fontSize: '1rem',
            fontWeight: 400,
            fontFamily: theme.typography.fontFamily,
            letterSpacing: theme.typography.body1.letterSpacing,
        },
        submitButton: {
            position: 'absolute',
            right: 0,
        },
    });
});
var DeckCategoryEditorField = function (_a) {
    var _b = _a.editMode, editMode = _b === void 0 ? false : _b, value = _a.value, onChange = _a.onChange, onSubmit = _a.onSubmit, variant = _a.variant, _c = _a.TextFieldProps, TextFieldProps = _c === void 0 ? {} : _c;
    var classes = exports.useStyles();
    var handleFormSubmission = react_1.useCallback(function (event) {
        event.preventDefault();
        onSubmit();
    }, [onSubmit]);
    return (react_1.default.createElement(core_1.ListItem, { className: classes.root },
        react_1.default.createElement(core_1.ListItemText, { disableTypography: true },
            react_1.default.createElement("form", { onSubmit: handleFormSubmission },
                react_1.default.createElement(TextField_1.default, __assign({ id: "new-" + variant + "-field", name: "new-" + variant, fullWidth: true, multiline: true, size: "medium", placeholder: editMode
                        ? (variant === 'category' ? 'Category' : 'Subcategory') + " name"
                        : "Add a " + variant, value: value, 
                    // className={classes.textField}
                    InputBaseProps: {
                        className: classes.textField,
                    }, onKeyDown: function (event) {
                        if (event.key === 'Enter' ||
                            event.which === 13 ||
                            event.keyCode === 13) {
                            event.preventDefault();
                            onSubmit();
                        }
                    }, onChange: onChange }, TextFieldProps)),
                value && (react_1.default.createElement(IconButton_1.default, { type: "submit", className: classes.submitButton },
                    react_1.default.createElement(DoneOutlineRounded_1.default, null)))))));
};
exports.default = DeckCategoryEditorField;
//# sourceMappingURL=DeckCategoryEditorField.js.map